import { OnlineEventSpecification } from './OnlineEventSpecification';
import { Event } from './Event';
import { Country } from './Country';

export class OnlineEvent {
    public id: number;
    public eventNameDe: string;
    public eventNameIt: string;
    public eventNameEn: string;
    public eventDescriptionDe: string;
    public eventDescriptionIt: string;
    public eventDescriptionEn: string;
    public startDate: string;
    public endDate: string;
    public latitude: string;
    public longitude: string;
    public onlinePublish: false | boolean;
    public pictureName: string;
    public startHour: string;
    public event: Event;
    public specifications: OnlineEventSpecification[];
    public area: string;
    public location: string;
    public country: Country;

    public static fromDto(e): OnlineEvent {
        const onlineEvent = new OnlineEvent();
        if (!e) {
            return null;
        }

        onlineEvent.id = e.id;
        onlineEvent.eventNameDe = e.eventNameDe;
        onlineEvent.eventNameIt = e.eventNameIt;
        onlineEvent.eventNameEn = e.eventNameEn;
        onlineEvent.eventDescriptionDe = e.eventDescriptionDe;
        onlineEvent.eventDescriptionIt = e.eventDescriptionIt;
        onlineEvent.eventDescriptionEn = e.eventDescriptionEn;
        onlineEvent.startDate = e.startDate;
        onlineEvent.endDate = e.endDate;
        onlineEvent.latitude = e.latitude;
        onlineEvent.longitude = e.longitude;
        onlineEvent.onlinePublish = e.onlinePublish;
        onlineEvent.pictureName = e.pictureName;
        onlineEvent.startHour = e.startHour;
        onlineEvent.event = Event.fromDto(e.event);
        onlineEvent.specifications = e.specifications?.map((s: any) => OnlineEventSpecification.fromDto(s));
        onlineEvent.area = e.area;
        onlineEvent.location = e.location;
        onlineEvent.country = Country.fromDto(e.country);

        return onlineEvent;
    }
}
